(function (module) {
    "use strict";

    module.component('chartTypeConfig', {
        template: require('./chartTypeConfigComponent.html'),
        bindings: {
            titleChart: "@",
            showValue: "=",
            showChart: "=",
            forecastType: "<",
            showTableButton:"@",
            showButtonBar: "<",
            showInMilions: '='
        },
        controller: ['$scope', function(this: $TSFixMe, $scope: $TSFixMe) {
            var $ctrl = this;
            $ctrl.$onInit = function () {
                $ctrl.showChart = true;
            }
        }]
    })

})(angular.module('topline.modules'));